import "antd-mobile/es/nav-bar/style";
import _NavBar from "antd-mobile/es/nav-bar";
/**
 * @module: 公用头部
 * @author: LiangHuang
 * @date: 2019-10-10 16:12:47
 */

import React from 'react'; // import { withRouter } from 'react-router-dom';
// import { RouteComponentProps } from 'react-router';

import './style'; // import { NavBarProps } from 'antd-mobile/lib/nav-bar/PropsType';

import PropTypes from 'prop-types'; // export interface IHeader extends RouteComponentProps, NavBarProps {
//   children?: ReactNode;
// }

var Header = function Header(props) {
  var rightContent = props.rightContent,
      mode = props.mode,
      onLeftClick = props.onLeftClick,
      icon = props.icon,
      className = props.className,
      leftContent = props.leftContent,
      style = props.style;

  var back = function back() {
    // 如果是非hybrid环境，执行浏览器goback
    if (window.YwkHybrid.os.ywk) {
      window.YwkHybrid.page.close({
        popPageNumber: 1
      });
    } else {
      window.history.back();
    }
  };

  return (
    /*#__PURE__*/
    React.createElement(React.Fragment, null,
    /*#__PURE__*/
    React.createElement(_NavBar, {
      style: style,
      leftContent: leftContent,
      rightContent: rightContent,
      mode: mode || 'light',
      onLeftClick: onLeftClick || back,
      icon: icon ||
      /*#__PURE__*/
      React.createElement("img", {
        className: "back-img",
        src: require('./imgs/icon-back.png'),
        alt: ""
      }),
      className: className ? "".concat(className, " navbar") : 'navbar'
    }, props.children))
  );
}; // const Header = withRouter(HHeader);


Header.propTypes = {
  prefixCls: PropTypes.string,
  className: PropTypes.string,
  mode: PropTypes.oneOf(['dark', 'light']),
  icon: PropTypes.node,
  leftContent: PropTypes.node,
  rightContent: PropTypes.node,
  onLeftClick: PropTypes.func,
  children: PropTypes.node,
  style: PropTypes.object
};
export default Header;